import {ArchiveRecord} from 'archive/ArchiveConstants';
import * as FolderConstants from 'constants/FolderConstants';
import {TagSchema} from 'constants/RegistryConstants';
import {BioentitySummary} from 'folder-items/FileConstants';
import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {EntrySummary, ProtocolSummary} from 'notebook/ELNConstants';
import {SchemaValidationState} from 'schemas/SchemaValidationConstants';

import {DatasetListingGraphQL} from '../../graphql-fragments/data-frames/__generated/DatasetListingGraphQL';

const INACCESSIBLE_MESSAGE = `The file you were trying to access is no longer available. It may have \
been deleted or moved into a project you do not have access to.`;

const SCHEMA_ID_TAG_SCHEMA_ALL = 'TAG_SCHEMA_ALL';
const SCHEMA_ID_BATCH_SCHEMA_ALL = 'BATCH_SCHEMA_ALL';

export type FolderItem =
  | FolderConstants.StringIDFolder
  | BioentitySummary
  | EntrySummary
  | ProtocolSummary
  | DatasetListingGraphQL;

export interface WorkspaceItem {
  id: string;
  archiveRecord: ArchiveRecord | null;
  fileId: string;
  name: string;
  // Note: WorkspaceItem.tagSchema will only be hydrated with tagSchema.iconId and tagSchema.id
  // TODO(Nao): Investigate getting icons for workspace tag schemas the "new way" (not via bootstrapped to_dict)
  tagSchema: TagSchema | null;
  schemaValidationState: SchemaValidationState | null;
  procedureType: ProcedureType | null;
}

export type WorkspaceItemInput = Pick<WorkspaceItem, 'name'> &
  Partial<Omit<WorkspaceItem, 'id' | 'fileId' | 'name'>>;

export type WorkspaceItemDispatchItem = Pick<WorkspaceItem, 'name' | 'tagSchema'>;

export type WorkspaceServerItem = Pick<WorkspaceItem, 'id' | 'fileId'>;

// Keep in sync with benchling/api/lib/search/search_params.py.
export const FILTER_PARENT_STORABLE_ROOT = 'root';

export const FileBrowerPreferences = {
  PAGE_SIZE: 'pageSize',
};

export const SEQUENCE_TYPE = {
  DOUBLE_STRANDED: 'ds',
  SINGLE_STRANDED: 'ss',
  OLIGO: 'oligo',
};

export const DENSITY = {
  COMFORTABLE: 'comfortable',
  COMPACT: 'compact',
};

export const NOTEBOOK_SECTION = FolderConstants.FolderSection.NOTEBOOK;
export const INVENTORY_SECTION = FolderConstants.FolderSection.INVENTORY;
export const ALL_SECTION = FolderConstants.FolderSection.ALL;

export const FINDER_ITEM_TYPE = {
  FILE: 'FILE',
  BATCH: 'BATCH',
  STORABLE: 'STORABLE',
};

export {INACCESSIBLE_MESSAGE, SCHEMA_ID_TAG_SCHEMA_ALL, SCHEMA_ID_BATCH_SCHEMA_ALL};
